import { makeStyles } from '@material-ui/core/styles';

export const useApiSelectStyles = makeStyles(() => ({
    root: {
        minHeight: '32px !important',
        fontSize: '14px',
    },
    controlWrap: {
        width: '100%',
    },
    option: {
        fontSize: '12px',
        fontWeight: 400,
        fontStyle: 'normal',
        lineHeight: '17px',
        color: 'rgba(120, 121, 142, 1)',
        backgroundColor: '#fff',
        display: 'block',
        minWidth: 0,
        maxWidth: '100%',
        overflow: 'hidden',
        '&:hover': {
            backgroundColor: '#f4f5f9',
        },
        '&.Mui-selected': {
            backgroundColor: '#eceef8',
        },
        '&.Mui-selected:hover': {
            backgroundColor: '#e4e7f4',
        },
    },
    ellipsisText: {
        display: 'block',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        width: '100%',
        minWidth: 0,
    },
    placeholderText: {
        color: '#999',
        fontSize: '12px',
        fontWeight: 400,
        padding: '5px 8px 6px 8px',
        fontStyle: 'normal',
        lineHeight: '17px',
    },
    menuPanel: {
        marginTop: '5px',
        padding: 0,
        fontSize: '12px',
        fontWeight: 400,
        fontStyle: 'normal',
        lineHeight: '17px',
        color: 'rgba(120, 121, 142, 1)',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        maxHeight: 280,
        backgroundColor: '#fff',
        boxShadow: '0 4px 16px rgba(0, 0, 0, 0.12)',
        overscrollBehavior: 'contain',
    },
    optionsViewport: {
        flex: '1 1 auto',
        minHeight: 0,
        maxHeight: 200,
        overflowY: 'auto',
        overflowX: 'hidden',
        backgroundColor: '#fff',
        WebkitOverflowScrolling: 'touch',
        overscrollBehavior: 'contain',
        touchAction: 'pan-y',
    },
    menuListInner: {
        maxHeight: 'none !important',
        overflow: 'visible !important',
        paddingTop: 0,
        paddingBottom: 0,
        backgroundColor: '#fff',
    },
    searchWrap: {
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        padding: '8px 10px',
        backgroundColor: '#fff',
        borderBottom: '1px solid rgba(213, 214, 221, 0.9)',
        zIndex: 1,
    },
    searchInput: {
        flex: 1,
        minWidth: 0,
        height: 32,
        padding: '6px 8px',
        fontSize: 12,
        lineHeight: '17px',
        color: 'rgba(33, 34, 52, 1)',
        backgroundColor: '#fafafa',
        border: '1px solid rgba(213, 214, 221, 1)',
        borderRadius: 4,
        outline: 'none',
        boxSizing: 'border-box',
        '&:focus': {
            borderColor: 'rgba(95, 96, 113, 0.85)',
            backgroundColor: '#fff',
        },
    },
    searchIconInline: {
        fontSize: 18,
        color: 'rgba(95, 96, 113, 0.85)',
        flexShrink: 0,
    },
    clearSearchBtn: {
        padding: 4,
    },
    noOptionsMessage: {
        padding: 12,
        fontSize: 12,
        color: 'rgba(120, 121, 142, 1)',
        textAlign: 'center',
        backgroundColor: '#fff',
    },
    menuFooter: {
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 8,
        padding: '8px 10px',
        borderTop: '1px solid rgba(213, 214, 221, 0.9)',
        backgroundColor: '#fff',
        fontSize: 11,
        fontWeight: 500,
        color: 'rgba(95, 96, 113, 1)',
        zIndex: 1,
    },
    loadingRow: {
        display: 'flex',
        justifyContent: 'center',
        padding: 16,
        backgroundColor: '#fff',
    },
}));

/** Control styles aligned with SimpleSelect — scoped to ApiSelect only. */
export const getApiSelectControlStyles = () => ({
    valueContainer: (base) => ({
        ...base,
        padding: '5px 8px 6px 8px',
        overflow: 'hidden',
    }),
    singleValue: (base) => ({
        ...base,
        fontSize: '12px',
        fontWeight: 400,
        padding: '5px 8px 6px 8px',
        fontStyle: 'normal',
        lineHeight: '17px',
        maxWidth: '100%',
        overflow: 'hidden',
    }),
    clearIndicator: (base) => ({
        ...base,
        padding: '2px',
        cursor: 'pointer',
        color: 'rgba(200, 0, 0, 0.6)',
        ':hover': { color: 'red' },
        svg: { width: '14px', height: '14px' },
    }),
    placeholder: (base) => ({
        ...base,
        color: '#999',
        fontSize: '12px',
        fontWeight: 400,
        padding: '5px 8px 6px 8px',
        fontStyle: 'normal',
        lineHeight: '17px',
    }),
    control: (provided) => ({
        ...provided,
        minHeight: '32px',
        height: '32px',
        fontSize: '12px',
        fontWeight: 400,
        fontStyle: 'normal',
        lineHeight: '17px',
        border: '1px solid rgba(213, 214, 221, 1) !important',
        boxShadow: 'none',
        '&:hover': {
            border: '1px solid rgba(213, 214, 221, 1)',
        },
    }),
    indicatorSeparator: () => ({ display: 'none' }),
    dropdownIndicator: (base) => ({
        ...base,
        alignSelf: 'flex-start',
        paddingTop: '7px',
        paddingBottom: 0,
        color: 'rgba(95, 96, 113, 1)',
        transform: 'translateX(-4px)',
        svg: { width: '16px', height: '16px' },
    }),
    menu: (base) => ({
        ...base,
        zIndex: 99999,
        backgroundColor: '#fff',
        overflow: 'hidden',
        overscrollBehavior: 'contain',
    }),
    menuPortal: (base) => ({
        ...base,
        zIndex: 99999,
        overscrollBehavior: 'contain',
    }),
    menuList: (base) => ({
        ...base,
        maxHeight: 'none',
        overflowY: 'visible',
        paddingTop: 0,
        paddingBottom: 0,
        backgroundColor: '#fff',
    }),
});
